export default "__VITE_ASSET__897f3d28__"